import { render } from "./smallVat.vue?vue&type=template&id=171ad9e9&scoped=true"
import script from "./smallVat.vue?vue&type=script&lang=js"
export * from "./smallVat.vue?vue&type=script&lang=js"

import "./smallVat.vue?vue&type=style&index=0&id=171ad9e9&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171ad9e9"]])

export default __exports__